<template>
  <div class="bottom">
    <img src="static/img/logowhite.png" alt="" />
    <p>地址：深圳市南山区粤海街道海珠社区海德二道288号茂业时代广场22A</p>
    <p style="margin-bottom: 0.2rem">Copyright &copy; 深圳青铜科技有限公司</p>
    <table></table>
  </div>
</template>
<script>
export default {
  name: "bottom",
  data() {
    return {};
  },
};
</script>
<style scoped>
.bottom {
  background: rgb(53, 53, 55);
  color: white;
  font-size: 0.09375rem;
  text-align: center;
}
.bottom img {
  margin: 0.333333rem auto;
  width: 1.09375rem;
}
.bottom p {
  margin: 0.052083rem auto;
}
</style>


// WEBPACK FOOTER //
// src/components/bottom.vue